<template lang="pug">
.m-card
  .m-card-header-wrapper(
    v-if="source.items != null && source.items[0] != null && source.items.length == 4"
    :data-bs-toggle="source.items[0].marketId != 3 ? 'collapse' : null"
    :href="source.items[0].marketId != 3 ? '#collapse-match-' + index + source.items[0].marketId : null"
    role='button'
    :aria-expanded="source.items[0].marketId == 3 ? 'true' : 'false'"
    :aria-controls="'collapse-match-' + index + source.items[0].marketId"
  )
    //- small {{ source.items[0] }}
    efTimer(:source="source.items[0]")
  .m-card-body.collapse.show(
    v-if="source.items[0].marketId != 3"
    :id="'collapse-match-' + index + source.items[0].marketId"
  )
    .m-card-item
      .m-card-wrap
        .m-group
          .team-group.yellow-team
            img.icon(src='images/vgame/marble-clash-characters/ball-yellow.svg')
            span {{ $t("ui.yellow") }}
          .section.winners-market
            .odds-group
              .m-label-top
                img(src='images/vgame/crown/no1.svg')
                |  {{ $t("ui.no1") }}
              template(v-if="source.items[2] && source.items[2].details['ml'] && source.items[2].details['ml'][0] && source.items[2].details['ml'][0][5] != 0 && source.items[2].details['ml'][0][5] != ''")
                OddsItem.col(:odds="source.items[2].details['ml'][0]" idx=5 :typ="oddsType" dataType="2" mode="ml" :details="source.items[2].details" homeAway="1" label="ML0")
              template(v-else)
                OddsDisabled
          .section.normal-market
            .m-label-top {{ $t("ui.best_5_balls") }}
            .odds-group
              template(v-if="source.items[0] && source.items[0].details['ou'] && source.items[0].details['ou'][0] && source.items[0].details['ou'][0][12] != 0 && source.items[0].details['ou'][0][12] != ''")
                OddsItem.col(:odds="source.items[0].details['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" count=0 :details="source.items[0].details" homeAway="1")
              template(v-else)
                OddsDisabled
              template(v-if="source.items[0] && source.items[0].details['ou'] && source.items[0].details['ou'][0] && source.items[0].details['ou'][0][11] != 0 && source.items[0].details['ou'][0][11] != ''")
                OddsItem.col(:odds="source.items[0].details['ou'][0]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" count=0 :details="source.items[0].details" homeAway="2")
              template(v-else)
                OddsDisabled
              template(v-if="source.items[0] && source.items[0].details['oe'] && source.items[0].details['oe'][0] && source.items[0].details['oe'][0][5] != 0 && source.items[0].details['oe'][0][5] != ''")
                OddsItem.col(:odds="source.items[0].details['oe'][0]" idx=5 :typ="oddsType" dataType="2" mode="oe" label="odd")
              template(v-else)
                OddsDisabled
              template(v-if="source.items[0] && source.items[0].details['oe'] && source.items[0].details['oe'][0] && source.items[0].details['oe'][0][7] != 0 && source.items[0].details['oe'][0][7] != ''")
                OddsItem.col(:odds="source.items[0].details['oe'][0]" idx=7 :typ="oddsType" dataType="2" mode="oe" label="even")
              template(v-else)
                OddsDisabled
          .section.normal-market
            .odds-group
              .col
                template(v-if="source.items[3] && source.items[3].details['cs'] && source.items[3].details['cs'][5] && source.items[3].details['cs'][5][5] != 0 && source.items[3].details['cs'][5][5] != ''")
                  OddsItem.col(:odds="source.items[3].details['cs'][5]" idx=5 :typ="oddsType" dataType="3" label="5_0")
                template(v-else)
                  OddsDisabled  
              .col
                template(v-if="source.items[3] && source.items[3].details['cs'] && source.items[3].details['cs'][4] && source.items[3].details['cs'][4][5] != 0 && source.items[3].details['cs'][4][5] != ''")
                  OddsItem.col(:odds="source.items[3].details['cs'][4]" idx=5 :typ="oddsType" dataType="3" label="4_1")
                template(v-else)
                  OddsDisabled
              .col
                template(v-if="source.items[3] && source.items[3].details['cs'] && source.items[3].details['cs'][3] && source.items[3].details['cs'][3][5] != 0 && source.items[3].details['cs'][3][5] != ''")
                  OddsItem.col(:odds="source.items[3].details['cs'][3]" idx=5 :typ="oddsType" dataType="3" label="3_2")
                template(v-else)
                  OddsDisabled
              .col
                template(v-if="source.items[3] && source.items[3].details['oxt'] && source.items[3].details['oxt'][0] && source.items[3].details['oxt'][0][5] != 0 && source.items[3].details['oxt'][0][5] != ''")
                  OddsItem.col(:odds="source.items[3].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2" label="1X20")
                template(v-else)
                  OddsDisabled
        .m-group
          .team-group.blue-team
            img.icon(src='images/vgame/marble-clash-characters/ball-blue.svg')
            span {{ $t("ui.blue") }}
          .section.winners-market
            .odds-group
              .m-label-top
                img(src='images/vgame/crown/no1.svg')
                |  {{ $t("ui.no1") }}
              template(v-if="source.items[2] && source.items[2].details['ml'] && source.items[2].details['ml'][0] && source.items[2].details['ml'][0][5] != 0 && source.items[2].details['ml'][0][5] != ''")
                OddsItem.col(:odds="source.items[2].details['ml'][0]" idx=5 :typ="oddsType" dataType="2" mode="ml" :details="source.items[2].details" homeAway="2" label="ML0")
              template(v-else)
                OddsDisabled
          .section.normal-market
            .odds-group
              template(v-if="source.items[1] && source.items[1].details['ou'] && source.items[1].details['ou'][0] && source.items[1].details['ou'][0][12] != 0 && source.items[1].details['ou'][0][12] != ''")
                OddsItem.col(:odds="source.items[1].details['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" count=0 :details="source.items[1].details" homeAway="1")
              template(v-else)
                OddsDisabled
              template(v-if="source.items[1] && source.items[1].details['ou'] && source.items[1].details['ou'][0] && source.items[1].details['ou'][0][11] != 0 && source.items[1].details['ou'][0][11] != ''")
                OddsItem.col(:odds="source.items[1].details['ou'][0]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" count=0 :details="source.items[1].details" homeAway="2")
              template(v-else)
                OddsDisabled
              template(v-if="source.items[1] && source.items[1].details['oe'] && source.items[1].details['oe'][0] && source.items[1].details['oe'][0][5] != 0 && source.items[1].details['oe'][0][5] != ''")
                OddsItem.col(:odds="source.items[1].details['oe'][0]" idx=5 :typ="oddsType" dataType="2" mode="oe" label="odd")
              template(v-else)
                OddsDisabled
              template(v-if="source.items[1] && source.items[1].details['oe'] && source.items[1].details['oe'][0] && source.items[1].details['oe'][0][7] != 0 && source.items[1].details['oe'][0][7] != ''")
                OddsItem.col(:odds="source.items[1].details['oe'][0]" idx=7 :typ="oddsType" dataType="2" mode="oe" label="even")
              template(v-else)
                OddsDisabled
          .section.normal-market
            .odds-group
              .col
                template(v-if="source.items[3] && source.items[3].details['cs'] && source.items[3].details['cs'][0] && source.items[3].details['cs'][0][5] != 0 && source.items[3].details['cs'][0][5] != ''")
                  OddsItem.col(:odds="source.items[3].details['cs'][0]" idx=5 :typ="oddsType" dataType="3" label="0_5")
                template(v-else)
                  OddsDisabled  
              .col
                template(v-if="source.items[3] && source.items[3].details['cs'] && source.items[3].details['cs'][1] && source.items[3].details['cs'][1][5] != 0 && source.items[3].details['cs'][1][5] != ''")
                  OddsItem.col(:odds="source.items[3].details['cs'][1]" idx=5 :typ="oddsType" dataType="3" label="1_4")
                template(v-else)
                  OddsDisabled
              .col
                template(v-if="source.items[3] && source.items[3].details['cs'] && source.items[3].details['cs'][2] && source.items[3].details['cs'][2][5] != 0 && source.items[3].details['cs'][2][5] != ''")
                  OddsItem.col(:odds="source.items[3].details['cs'][2]" idx=5 :typ="oddsType" dataType="3" label="2_3")
                template(v-else)
                  OddsDisabled
              .col
                template(v-if="source.items[3] && source.items[3].details['oxt'] && source.items[3].details['oxt'][0] && source.items[3].details['oxt'][0][7] != 0 && source.items[3].details['oxt'][0][7] != ''")
                  OddsItem.col(:odds="source.items[3].details['oxt'][0]" idx=7 :typ="oddsType" dataType="2" label="1X20")
                template(v-else)
                  OddsDisabled




//- .marble-clash-group
//-   .eracing-mainmarket-item.collapsed(
//-     v-if="source.items != null && source.items[0] != null && source.items.length == 4"
//-     type='button' 
//-     :id="source.items[0].id"
//-     data-toggle='collapse' 
//-     :data-target="'#mainmarket-' + source.items[0].matchId"
//-   )
//-     //- .row.m-0.align-items-center
//-     efTimer(:source="source.items[0]" :class="{ 'd-none' : source.items[0].marketId == 3 }")
//-       //- .mr-2.time-remaining.red-text
//-       //-   i.far.fa-stopwatch
//-       //-   span 58s
//-     .live-icon-wrapper(:class="{ 'd-none' : source.items[0].marketId != 3 }")
//-       img.live-icon(src='images/egame/live-icon.svg')
//-       span.mx-1 LIVE
//-       .live-dot
//-   .collapse.show(
//-     :id="'mainmarket-' + source.items[0].matchId"
//-   )
//-     .match-collapse-body
//-       //- small {{ source.items[3].details }}
//-       .marble-market-group
//-         .red-team
//-           img(src='images/egame/marble-clash-characters/ball-yellow.svg')
//-           span {{ $t("ui.yellow") }}
//-         .winners-market.flex-wrap
//-           .d-flex.align-items-center.justify-content-between
//-             .d-flex.align-items-center.justify-content-center.mt-2.mb-2.player-info-wrapper
//-               img.characters(src='images/egame/crown/no1.svg')
//-               .ml-2.player-name-wrapper
//-                 | {{ $t("ui.no1") }}
//-             .odds-group
//-               .bettype-col {{ $t("m.GC_ML0") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[2] && source.items[2].details['ml'] && source.items[2].details['ml'][0] && source.items[2].details['ml'][0][5] != 0 && source.items[2].details['ml'][0][5] != ''")
//-                   OddsItem(:odds="source.items[2].details['ml'][0]" idx=5 :typ="oddsType" dataType="2" mode="ml" :details="source.items[2].details" homeAway="1")
//-                 template(v-else)
//-                   OddsDisabled
//-         .normal-market
//-           .bettype {{ $t("ui.best_5_balls") }}
//-           .d-flex.justify-content-center
//-             .odds-group
//-               .bettype-col {{ $t("m.GC_OVER") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[0] && source.items[0].details['ou'] && source.items[0].details['ou'][0] && source.items[0].details['ou'][0][12] != 0 && source.items[0].details['ou'][0][12] != ''")
//-                   OddsItem(:odds="source.items[0].details['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" count=0 :details="source.items[0].details" homeAway="1")
//-                 template(v-else)
//-                   OddsDisabled
//-             .odds-group
//-               .bettype-col {{ $t("m.GC_UNDER") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[0] && source.items[0].details['ou'] && source.items[0].details['ou'][0] && source.items[0].details['ou'][0][11] != 0 && source.items[0].details['ou'][0][11] != ''")
//-                   OddsItem(:odds="source.items[0].details['ou'][0]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" count=0 :details="source.items[0].details" homeAway="2")
//-                 template(v-else)
//-                   OddsDisabled
//-             .odds-group
//-               .bettype-col {{ $t("m.GC_ODD") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[0] && source.items[0].details['oe'] && source.items[0].details['oe'][0] && source.items[0].details['oe'][0][5] != 0 && source.items[0].details['oe'][0][5] != ''")
//-                   OddsItem(:odds="source.items[0].details['oe'][0]" idx=5 :typ="oddsType" dataType="2" label="odd")
//-                 template(v-else)
//-                   OddsDisabled
//-             .odds-group
//-               .bettype-col {{ $t("m.GC_EVEN") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[0] && source.items[0].details['oe'] && source.items[0].details['oe'][0] && source.items[0].details['oe'][0][7] != 0 && source.items[0].details['oe'][0][7] != ''")
//-                   OddsItem(:odds="source.items[0].details['oe'][0]" idx=7 :typ="oddsType" dataType="2" label="even")
//-                 template(v-else)
//-                   OddsDisabled
//-         .normal-market.border-bottom-0
//-           .d-flex.justify-content-center
//-             .odds-group
//-               .bettype-col {{ $t("m.GC_5_0") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[3] && source.items[3].details['cs'] && source.items[3].details['cs'][5] && source.items[3].details['cs'][5][5] != 0 && source.items[3].details['cs'][5][5] != ''")
//-                   OddsItem(:odds="source.items[3].details['cs'][5]" idx=5 :typ="oddsType" dataType="3")
//-                 template(v-else)
//-                   OddsDisabled
//-             .odds-group
//-               .bettype-col {{ $t("m.GC_4_1") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[3] && source.items[3].details['cs'] && source.items[3].details['cs'][4] && source.items[3].details['cs'][4][5] != 0 && source.items[3].details['cs'][4][5] != ''")
//-                   OddsItem(:odds="source.items[3].details['cs'][4]" idx=5 :typ="oddsType" dataType="3")
//-                 template(v-else)
//-                   OddsDisabled
//-             .odds-group
//-               .bettype-col {{ $t("m.GC_3_2") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[3] && source.items[3].details['cs'] && source.items[3].details['cs'][3] && source.items[3].details['cs'][3][5] != 0 && source.items[3].details['cs'][3][5] != ''")
//-                   OddsItem(:odds="source.items[3].details['cs'][3]" idx=5 :typ="oddsType" dataType="3")
//-                 template(v-else)
//-                   OddsDisabled
//-             .odds-group
//-               .bettype-col {{ $t("m.GC_1X20") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[3] && source.items[3].details['oxt'] && source.items[3].details['oxt'][0] && source.items[3].details['oxt'][0][5] != 0 && source.items[3].details['oxt'][0][5] != ''")
//-                   OddsItem(:odds="source.items[3].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2")
//-                 template(v-else)
//-                   OddsDisabled

//-         .blue-team
//-           img(src='images/egame/marble-clash-characters/ball-blue.svg')
//-           span {{ $t("ui.blue") }}
//-         .winners-market.flex-wrap
//-           .d-flex.align-items-center.justify-content-between
//-             .d-flex.align-items-center.justify-content-center.mt-2.mb-2.player-info-wrapper
//-               img.characters(src='images/egame/crown/no1.svg')
//-               .ml-2.player-name-wrapper
//-                 | {{ $t("ui.no1") }}
//-             .odds-group
//-               .bettype-col {{ $t("m.GC_ML0") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[2] && source.items[2].details['ml'] && source.items[2].details['ml'][0] && source.items[2].details['ml'][0][7] != 0 && source.items[2].details['ml'][0][7] != ''")
//-                   OddsItem(:odds="source.items[2].details['ml'][0]" idx=7 :typ="oddsType" dataType="2" mode="ml" :details="source.items[2].details" homeAway="2")
//-                 template(v-else)
//-                   OddsDisabled
//-         .normal-market
//-           .bettype {{ $t("ui.best_5_balls") }}
//-           .d-flex.justify-content-center
//-             .odds-group
//-               .bettype-col {{ $t("m.GC_OVER") }}
//-               template(v-if="source.items[1].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[1] && source.items[1].details['ou'] && source.items[1].details['ou'][0] && source.items[1].details['ou'][0][12] != 0 && source.items[1].details['ou'][0][12] != ''")
//-                   OddsItem(:odds="source.items[1].details['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" count=0 :details="source.items[1].details" homeAway="1")
//-                 template(v-else)
//-                   OddsDisabled
//-             .odds-group
//-               .bettype-col {{ $t("m.GC_UNDER") }}
//-               template(v-if="source.items[1].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[1] && source.items[1].details['ou'] && source.items[1].details['ou'][0] && source.items[1].details['ou'][0][11] != 0 && source.items[1].details['ou'][0][11] != ''")
//-                   OddsItem(:odds="source.items[1].details['ou'][0]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" count=0 :details="source.items[1].details" homeAway="2")
//-                 template(v-else)
//-                   OddsDisabled
//-             .odds-group
//-               .bettype-col {{ $t("m.GC_ODD") }}
//-               template(v-if="source.items[1].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[1] && source.items[1].details['oe'] && source.items[1].details['oe'][0] && source.items[1].details['oe'][0][5] != 0 && source.items[1].details['oe'][0][5] != ''")
//-                   OddsItem(:odds="source.items[1].details['oe'][0]" idx=5 :typ="oddsType" dataType="2" label="odd")
//-                 template(v-else)
//-                   OddsDisabled
//-             .odds-group
//-               .bettype-col {{ $t("m.GC_EVEN") }}
//-               template(v-if="source.items[1].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[1] && source.items[1].details['oe'] && source.items[1].details['oe'][0] && source.items[1].details['oe'][0][7] != 0 && source.items[1].details['oe'][0][7] != ''")
//-                   OddsItem(:odds="source.items[1].details['oe'][0]" idx=7 :typ="oddsType" dataType="2" label="even")
//-                 template(v-else)
//-                   OddsDisabled
//-         .normal-market.border-bottom-0
//-           .d-flex.justify-content-center
//-             .odds-group
//-               .bettype-col {{ $t("m.GC_0_5") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[3] && source.items[3].details['cs'] && source.items[3].details['cs'][0] && source.items[3].details['cs'][0][5] != 0 && source.items[3].details['cs'][0][5] != ''")
//-                   OddsItem(:odds="source.items[3].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
//-                 template(v-else)
//-                   OddsDisabled
//-             .odds-group
//-               .bettype-col {{ $t("m.GC_1_4") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[3] && source.items[3].details['cs'] && source.items[3].details['cs'][1] && source.items[3].details['cs'][1][5] != 0 && source.items[3].details['cs'][1][5] != ''")
//-                   OddsItem(:odds="source.items[3].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
//-                 template(v-else)
//-                   OddsDisabled
//-             .odds-group
//-               .bettype-col {{ $t("m.GC_2_3") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[3] && source.items[3].details['cs'] && source.items[3].details['cs'][2] && source.items[3].details['cs'][2][5] != 0 && source.items[3].details['cs'][2][5] != ''")
//-                   OddsItem(:odds="source.items[3].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
//-                 template(v-else)
//-                   OddsDisabled
//-             .odds-group
//-               .bettype-col {{ $t("m.GC_1X20") }}
//-               template(v-if="source.items[0].marketId == 3")
//-                 OddsDisabled
//-               template(v-else)
//-                 template(v-if="source.items[3] && source.items[3].details['oxt'] && source.items[3].details['oxt'][0] && source.items[3].details['oxt'][0][7] != 0 && source.items[3].details['oxt'][0][7] != ''")
//-                   OddsItem(:odds="source.items[3].details['oxt'][0]" idx=7 :typ="oddsType" dataType="2")
//-                 template(v-else)
//-                   OddsDisabled

</template>

<script>
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    efTimer: () => import("@/components/mobile/efight/efTimer"),
    OddsItem: () => import("@/components/mobile/main/xitem/oddsItem"),
    OddsDisabled: () => import("@/components/mobile/main/xitem/oddsDisabled")
  },
  mixins: [mixinHDPOUOdds],
  props: {
    source: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: { 
    oddsType() {
      return this.$store.getters.pageDisplay.oddsType;
    }
   },
  methods: {
    team(player, pos, isTeam) {
      if(isTeam) {
        var n = player.homeTeam;
        return n;
      } else {
        var n = player.homeTeam.split(" - ")[pos];
        return n;
      }
    },
    getImage(x) {
      return "images/vgame/marble-survival/ball" + String(this.team(x, 0)) +".svg";
    }
  }
};
</script>